export const getCores = (tamanho:any) => {
    let cores =
        [
            "#36A2EB",
            "#FF6384",
            "#FFCE56",
            "#4CAF50",
            "#FFC107",
            "#4BC0C0",
            "#ff5733",
            "#33dbff",
            "#D35400",
            "#2196F3",
            "#1D8348",
            "#A569BD",
            "#922B21",
        ];

    for (let i = cores.length; i < tamanho; i++) {
        cores.push("#" + ((1 << 24) * Math.random() | 0).toString(16));
    }
    return cores
}